import { Illustration, Pictogram } from '@eti/components';
import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
import { useMediaQuery } from 'usehooks-ts';
import { useDirection, useSiteContext } from '@eti/providers';
import { getProductIllustrationId, getProductPictogramId } from '../utils/icon/getProductImageryIds';
import { jsx as _jsx } from "react/jsx-runtime";
const pictogramStyles = css`
  margin-inline-end: 8px;
  margin-top: 2px;
`;
const DialogIllustration = ({
  productName
}) => {
  var _getProductIllustrati;
  const {
    brand
  } = useSiteContext();
  const {
    isRTL
  } = useDirection();
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints._768})`);
  return isDesktop ? /*#__PURE__*/_jsx(Illustration, {
    brand: brand.code,
    id: (_getProductIllustrati = getProductIllustrationId(productName, isRTL)) !== null && _getProductIllustrati !== void 0 ? _getProductIllustrati : getProductIllustrationId('fallback', isRTL),
    mirrored: isRTL
  }) : /*#__PURE__*/_jsx(Pictogram, {
    brand: brand.code,
    className: pictogramStyles,
    height: 64,
    id: getProductPictogramId(productName, isRTL),
    mirrored: isRTL,
    width: 64
  });
};
export default DialogIllustration;
//# sourceMappingURL=DialogIllustration.js.map